import { AiAnalysis } from "../../../services/sheai/SheAiChecklistTypes";
import { eixosDoRelatorio } from "../modules/checklistReport";

/**
 * A semente do "Feedback ao estudante": o rascunho inicial derivado da
 * análise de vídeo da IA, que o avaliador revisa antes de publicar.
 *
 * Acertos e pontos a melhorar saem da MESMA regra do relatório da aba Dados
 * IA (`eixosDoRelatorio` — veredito `done` vira acerto, o resto vira ponto a
 * melhorar), aqui achatada numa lista única: o estudante recebe um retorno
 * só, não um relatório por Habilidade. Visão geral é um resumo factual dos
 * vereditos. Recomendações e orientação final começam vazias de propósito —
 * são julgamento pedagógico, não dá para inferir do veredito (a mesma razão
 * pela qual o relatório só mostra `proximoPasso` quando o agente o envia).
 */

export interface SementeFeedback {
  overview: string;
  strengths: string[];
  improvements: string[];
}

const RESUMO_RESULTADO: Record<string, string> = {
  done: "atendidos",
  partially_done: "parcialmente atendidos",
  done_wrong: "executados de forma incorreta",
  not_done: "não atendidos",
};

function resumoDosVereditos(analise: AiAnalysis): string {
  const itens = analise.items || [];
  const contagem: Record<string, number> = {};
  itens.forEach((item) => {
    contagem[item.result] = (contagem[item.result] ?? 0) + 1;
  });

  const partes = Object.keys(RESUMO_RESULTADO)
    .filter((resultado) => contagem[resultado])
    .map((resultado) => `${contagem[resultado]} ${RESUMO_RESULTADO[resultado]}`);

  if (partes.length === 0) return "";

  const criticos = itens.filter(
    (item) =>
      item.critical &&
      (item.result === "not_done" || item.result === "done_wrong")
  ).length;

  const base = `A análise por vídeo avaliou ${itens.length} itens do checklist: ${partes.join(
    ", "
  )}.`;

  return criticos > 0
    ? `${base} ${criticos} ${criticos === 1 ? "item crítico ficou" : "itens críticos ficaram"} sem atendimento adequado.`
    : base;
}

export function sementeDaAnalise(
  analise: AiAnalysis | null,
  perguntaPorItem?: Record<string, string>
): SementeFeedback | null {
  if (!analise || (analise.items || []).length === 0) return null;

  const eixos = eixosDoRelatorio(analise, perguntaPorItem);

  return {
    overview: resumoDosVereditos(analise),
    strengths: eixos.flatMap((eixo) =>
      eixo.acertos.map((a) => a.observacao || a.pergunta)
    ),
    improvements: eixos.flatMap((eixo) =>
      eixo.melhorar.map((a) => a.observacao || a.pergunta)
    ),
  };
}
